export const modalStyles = {
    content: {
        padding: "0 0 8px 0",
        border: "unset",
        width: "480px",
    },
};
